<script setup lang="ts">
import type { Component } from "vue";
import IconManager from "@/core/IconManager.vue";
import { DashboardTrend } from "@/modules/executiveDashboard/models/dashboard-trend.enum";
interface Props {
  title: string;
  value?: string | number | null;
  icon?: Component;
  backgroundColor?: string;
  textColor?: string;
  change?: string;
  trend?: DashboardTrend;
  callBack?: () => Promise<void>;
}

const props = withDefaults(defineProps<Props>(), {
  backgroundColor: "#FFF",
  textColor: "#000",
});
</script>

<template>
  <div
    class="flex flex-row items-center gap-4 bg-white border-[#E5E9EF] rounded-xl p-2 shadow-sm hover:shadow-lg hover:scale-105 transition-all duration-200"
    @click="callBack ? callBack() : null"
  >
    <div
      v-if="$slots.default"
      class="p-3 rounded-xl"
      :style="{ backgroundColor: props.backgroundColor }"
    >
      <slot></slot>
    </div>

    <div class="flex flex-col">
      <div class="font-bold uppercase text-xs text-light-gray">{{ title }}</div>
      <div :style="{ color: props.textColor }" class="font-bold text-xl">
        {{ value }}
      </div>
      <div
        v-if="trend && trend != DashboardTrend.Stable"
        class="flex flex-row gap-2 items-center"
      >
        <IconManager
          name="TriangleUp"
          class="transition-transform duration-200"
          :style="{ color: props.textColor }"
          :class="trend == DashboardTrend.Up ? 'rotate-0' : 'rotate-180'"
        />
        <span :style="{ color: props.textColor }">{{ change }}</span>
      </div>
    </div>
  </div>
</template>
